import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ReleaseRefundCustomerModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ReleaseRefundCustomerModal extends Component {
    constructor(props) {
		super(props);
		this.state = { 
			face: 0,
			total: 0,
        }
    }

	componentWillReceiveProps(props) {
		let face = 0;
		let total = 0;
		if (props.refundDetails) {
			props.refundDetails.forEach((refundDetail) => {
				total += refundDetail.price;
				if (refundDetail.transaction_tickets_id) {
					face += refundDetail.price;
				}
				if (refundDetail.transaction_flexpass_id) {
					face += refundDetail.price;
				}
				if (refundDetail.tender_type === 'Donation') {
					face += refundDetail.price;
				}
				if (refundDetail.type === 'custom' && refundDetail.service_fee === 'customer') {
					face += refundDetail.price;
				}
			});
		}
		this.setState({
			face,
			total,
		});
	}

    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isReleaseRefundCustomerOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleReleaseRefundModal}>{strings.title}</ModalHeader>
		          	<ModalBody>
						<h3>
							{strings.refundTitle1} 
							<br />
							({new Intl.NumberFormat('en-US', {
								style: 'currency',
								currency: 'USD'
							}).format(this.state.face)})
						</h3>
						<p>{strings.refundDesc1}</p>
						<p>{strings.patrons}</p>
						<table className="showtix-table showtix-table__striped">
							<thead>
								<tr>
									<th>
										{strings.tickets}
									</th>
									<th>
										{strings.donation}
									</th>
									<th>
										{strings.customFees}
									</th>
									<th>
										{strings.showtixFees}
									</th>
									<th>
										{strings.mailingFees}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="is-right">
										√
									</td>
									<td className="is-right">
										√
									</td>
									<td className="is-right">
										√
									</td>
									<td className="is-wrong">
										X
									</td>
									<td className="is-wrong">
										X
									</td>
								</tr>
							</tbody>
						</table>
						<div className="d-flex justify-content-center mt-4">
							<button 
								className="showtix-button showtix-background__grey-1"
								onClick={this.props.toggleReleaseRefundModal}
								>{strings.cancel}</button>
							<button 
								className="showtix-button showtix-background__primary-3"
								onClick={() => this.props.confirmCustomerRefund('customer')}
								>{strings.refund}</button>    
		          		</div>
						<hr />

						<h3>
							{strings.refundTitle2}
							<br />
							({new Intl.NumberFormat('en-US', {
								style: 'currency',
								currency: 'USD'
							}).format(this.state.total)})
						</h3>
						<p>{strings.refundDesc2}</p>
						<p>{strings.patrons}</p>
						<table className="showtix-table showtix-table__striped">
							<thead>
								<tr>
									<th>
										{strings.tickets}
									</th>
									<th>
										{strings.donation}
									</th>
									<th>
										{strings.customFees}
									</th>
									<th>
										{strings.showtixFees}
									</th>
									<th>
										{strings.mailingFees}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="is-right">
										√
									</td>
									<td className="is-right">
										√
									</td>
									<td className="is-right">
										√
									</td>
									<td className="is-right">
										√
										<span className="showtix-note">
											*
										</span>
									</td>
									<td className="is-wrong">
										X
									</td>
								</tr>
							</tbody>
						</table>
						<div className="showtix-note">{strings.ifFees}</div>
						<div className="d-flex justify-content-center mt-4">
							<button 
								className="showtix-button showtix-background__grey-1"
								onClick={this.props.toggleReleaseRefundModal}
								>{strings.cancel}</button>
							<button 
								className="showtix-button showtix-background__primary-3"
								onClick={() => this.props.confirmCustomerRefund('client')}
								>{strings.refund}</button>    
		          		</div>
					</ModalBody>
		        </Modal>
			</div>
	  	);
	}
}

ReleaseRefundCustomerModal.propTypes = {
    isReleaseRefundCustomerOpen: PropTypes.bool,
    toggleReleaseRefundModal: PropTypes.func,
    confirmAlertModal: PropTypes.func,
}

export default ReleaseRefundCustomerModal;


// WEBPACK FOOTER //
// ./src/components/Search/ReleaseRefundCustomerModal/ReleaseRefundCustomerModal.js